









import {
    Component,
    Prop,
    Advisor,
    BaseView,
    ComponentStyleDefinition,
    ComponentStyle,
    Recommendation
} from "@zoovu/runner-browser-api";

    @Component({})
    export default class StartOverButtonView extends BaseView {

        @Prop()
        advisor: Advisor;

        @Prop()
        advice: Recommendation;

        @ComponentStyle()
        componentStyle: ComponentStyleDefinition;

        startOver() {
            this.advice.setQuery("");
            this.advisor.startOver();
        }

        get rootElementClass(): string {
            return "start-over-button";
        }
    }
